import { LegalDocument } from '@/components/LegalDocument'
import { PRIVACY_HTML } from '@/legal/privacy.generated'
import { PRIVACY_VERSION } from '@parse/shared'

export function PrivacyPage() {
  return (
    <LegalDocument
      html={PRIVACY_HTML}
      title="Privacy Policy"
      version={PRIVACY_VERSION}
      lastUpdated="July 1, 2026"
    />
  )
}
